import { useState } from "react";
import BillGeneration from "./BillDetails";
import Account from "./Account";
import AnimalFood from "./AnimalFood";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

const DetailsTab = ({ mem_id, phone }) => {
  const [activeView, setActiveView] = useState(0);
  const handleChange = (event, newValue) => {
    setActiveView(newValue);
  };

  return (
    <div className="details-bg">
      <Tabs value={activeView} onChange={handleChange}
        variant="fullWidth"
        centered
        textColor="inherit"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#ff9800"
          }
        }}
        sx={{
          "& .MuiTab-root": {
            color: "#bbb",
            fontWeight: "bold",
            fontSize: "16px"
          },
          "& .Mui-selected": {
            color: "#ff9800"
          }
        }}
      >
        <Tab label="चालू" />
        <Tab label="मागील" />
        <Tab label="ऍडव्हान्स" />
        <Tab label="पशुखाद्य" />
      </Tabs>

      <TabPanel value={activeView} index={0}>
        <BillGeneration current={true} mem_id={mem_id} phone={phone} />
      </TabPanel>
      <TabPanel value={activeView} index={1}>
        <BillGeneration current={false} mem_id={mem_id} phone={phone} />
      </TabPanel>
      <TabPanel value={activeView} index={2}>
        <Account mem_id={mem_id} />
      </TabPanel>
      <TabPanel value={activeView} index={3}>
        <AnimalFood mem_id={mem_id} />
      </TabPanel>
    </div>
  );
};

export default DetailsTab;
